@import '../../utils/control-density.css';
@import '../../utils/chrome-header.css';
@import '../../utils/focus-ring.css';
@import '../../utils/interaction-fill.css';

:host {
  display: block;
  min-width: 0;
  box-sizing: border-box;
  background: var(--_shell-page-header-background, var(--color-background-primary));
}

:host([data-shell-page-syncing]) {
  visibility: hidden;
}

.bar-title {
  position: relative;
  min-width: 0;
  box-sizing: border-box;
  background: var(--_shell-page-header-background, var(--color-background-primary));
}

.bar-title::after {
  content: '';
  position: absolute;
  inset: auto var(--ds-bar-title-divider-inset, var(--dimension-space-400)) 0;
  height: var(--dimension-stroke-width-012);
  background: var(--color-border-tertiary);
  pointer-events: none;
}

.bar-title--divider-hidden::after {
  display: none;
}

.bar-title__inner {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--dimension-space-100);
  padding: var(--dimension-space-400);
  box-sizing: border-box;
}

.bar-title__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--dimension-space-100);
  min-height: var(--dimension-size-400);
  min-width: 0;
}

:host(.bar-title-host--expanded) .bar-title__row {
  gap: var(--dimension-space-400);
}

.bar-title__leading {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: var(--dimension-space-100);
  min-width: 0;
}

.bar-title__title-row {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-100);
  min-width: 0;
  min-height: var(--dimension-size-400);
}

.bar-title__identity {
  display: flex;
  flex: 0 1 auto;
  align-items: center;
  gap: var(--dimension-space-050);
  min-width: 0;
}

.bar-title__back,
.bar-title__section-chevron {
  flex: 0 0 auto;
}

.bar-title__breadcrumb {
  display: block;
  width: 100%;
  min-width: 0;
}

.bar-title__heading {
  display: block;
  width: auto;
  min-width: 0;
  user-select: none;
}

.bar-title__divider {
  width: var(--dimension-stroke-width-012);
  height: var(--dimension-size-250);
  margin-inline-start: var(--dimension-space-100);
  flex: 0 0 var(--dimension-stroke-width-012);
  background: var(--color-border-tertiary);
}

.bar-title__section-selector {
  display: flex;
  flex: 0 1 auto;
  min-width: 0;
  max-width: var(--dimension-panel-width-sm);
}

.bar-title__section-trigger {
  --ds-control-radius: var(--dimension-radius-half);

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--ds-control-gap);
  height: var(--ds-control-height);
  min-width: 0;
  max-width: 100%;
  padding-inline: var(--ds-control-padding-inline);
  border: none;
  border-radius: var(--ds-control-radius);
  box-sizing: border-box;
  background: transparent;
  color: var(--color-foreground-secondary);
  cursor: default;
  font-family: inherit;
  user-select: none;
}

.bar-title__section-trigger--expanded {
  color: var(--color-foreground-primary);
  --ds-interaction-hover: var(--ds-interaction-pressed);
}

.bar-title__section-trigger--expanded::after {
  background: var(--ds-interaction-pressed);
}

.bar-title__section-label {
  min-width: 0;
  padding-inline: var(--ds-control-label-inset);
}

.bar-title__actions {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-100);
  flex: 0 0 auto;
}

.bar-title__description {
  display: block;
  min-width: 0;
  max-width: 100%;
}

:host(.bar-title-host--compact) .bar-title {
  height: var(--dimension-size-600);
}

:host(.bar-title-host--compact) .bar-title::after {
  inset-inline: 0;
}

:host(.bar-title-host--compact) .bar-title__inner {
  flex: 1 1 auto;
  height: 100%;
  min-width: 0;
  padding: 0;
  gap: 0;
}

:host(.bar-title-host--compact) .bar-title__row {
  height: 100%;
  align-items: center;
}

:host(.bar-title-host--compact) .bar-title__identity {
  height: var(--dimension-size-400);
}

:host(.bar-title-host--compact) .bar-title__divider {
  margin-inline-start: 0;
}

:host(.bar-title-host--compact) .bar-title__heading {
  display: inline-flex;
  flex: 1 1 auto;
  align-items: center;
  height: var(--dimension-size-400);
  padding-inline: calc(var(--ds-control-padding-inline) + var(--ds-control-label-inset));
  box-sizing: border-box;
}
